import {appComponent, ESC_KEY} from '../../app.component';
import {breakpointLessThan, getBreakpoint} from '../../ui/components/detect-viewport-width';
import {gaLegacyCustomEvent} from '../../ga/ga-legacy.functions';
import {KeyboardTrap} from '../../ui/helpers/accessibility/keyboard-trap';
import {SessionStorageService} from '../../session-storage/session-storage.service';

export class BrowseSidebarComponent {
    public closeFilterButton: JQuery;
    public component: JQuery;

    constructor(private _sessionStorageService: SessionStorageService) {
        this.component = $(`[data-component='browse-sidebar-component']`);
        this._onInit();
    }

    private _onInit() {
        this._performElementBinding();
        this._registerEventHandlers();
        if (breakpointLessThan(`lg`, getBreakpoint()) && this._sessionStorageService.getItem(`flyout`) === `open`) {
            this.openFilter();
        }
    }

    /**
     * Closes the BrowseSidebarComponent in "flyout" mode
     */
    public closeFilter() {
        $(`html, body`).removeClass(`no-scroll`);
        this.component.removeClass(
            `!tw-block !tw-w-auto tw-fixed tw-z-[1027] tw-bg-white tw-h-[100vh] tw-top-0 tw-overflow-auto tw-w-[80vw] tw-max-w-[540px] tw-right-0`,
        );
        this._sessionStorageService.removeItem(`flyout`);
        appComponent.hideOverlay();
        $(`.side-bar-filters`).removeClass(`!tw-w-auto`).addClass(`tw-hidden`);
        $(`.divOverlay`)
            .removeClass(
                `!tw-block tw-bg-black tw-opacity-50 tw-h-full tw-bottom-0 tw-fixed tw-w-full tw-top-0 lg:tw-top-auto tw-left-0 tw-right-0 tw-z-[1026]`,
            )
            .addClass(`!tw-hidden`);
    }

    /**
     * Closes BrowseSidebarComponent on Esc key
     * @param eventObject
     */
    public static closeFilterOnEscKey(eventObject: JQueryKeyEventObject) {
        const component: BrowseSidebarComponent = eventObject.data.component;
        if (eventObject.which === ESC_KEY) {
            component.closeFilter();
        }
    }
    /**
     * Opens the BrowseSideBarComponent in "flyout" mode
     */
    public openFilter() {
        $(`html, body`).addClass(`no-scroll`);
        $(`.side-bar-filters`).removeClass(`tw-hidden`).addClass(`!tw-w-auto`);
        this.component.addClass(
            `!tw-block tw-fixed tw-z-[1027] tw-bg-white tw-h-[100vh] tw-top-0 tw-overflow-auto tw-w-[80vw] tw-max-w-[540px] tw-right-0`,
        );
        $(`.divOverlay`)
            .removeClass('!tw-hidden')
            .addClass(
                `!tw-block tw-bg-black tw-opacity-50 tw-h-full tw-bottom-0 tw-fixed tw-w-full tw-top-0 lg:tw-top-auto tw-left-0 tw-right-0 tw-z-[1026]`,
            );
        new KeyboardTrap(`.flyout`);
        this._sessionStorageService.setItem(`flyout`, `open`);
        appComponent.showOverlay();
        gaLegacyCustomEvent({eventAction: `Filter Button Menu Click`, eventCategory: `Faceted Search`, eventLabel: location.pathname});
    }

    /**
     * Binds component properties to jQuery selectors
     * @private
     */
    private _performElementBinding() {
        this.closeFilterButton = this.component.find(`[data-binding='closeFilterButton']`);
    }

    /**
     * Sets the event handlers for the template
     * @private
     */
    private _registerEventHandlers() {
        $(`.divOverlay`).on(`click`, this.closeFilter.bind(this));
        $(document).on(`keyup`, {component: this}, BrowseSidebarComponent.closeFilterOnEscKey);
        this.closeFilterButton.on(`click`, this.closeFilter.bind(this));
        (window as any).toggleBrowseFilters = this.openFilter.bind(this);
    }
}
